import { Project as Model } from '@dis/models';
const title = 'PROJECTS';
export { StateActions as ProjectsStateActions };
namespace StateActions {
  export class Create {
    public static readonly type = `[${title}] Create`;
    constructor(public payload: Model) {}
  }
  export class Delete {
    public static readonly type = `[${title}] Delete`;
    constructor(public payload: Model) {}
  }
  export class GetAll {
    public static readonly type = `[${title}] Get all`;
  }

  export class GetQuery {
    public static readonly type = `[${title}] Get query`;
  }

  export class FilterList {
    public static readonly type = `[${title}] Filter list`;
    constructor(public payload: string) {}
  }

  export class StartCollectionSheetWatcher {
    public static readonly type = `[${title}] Start Collection Sheet Watcher`;
  }

  export class UpdateFromSheetWatcher {
    public static readonly type = `[${title}] Update from Sheet Watcher`;
    constructor(public payload: Model[]) {}
  }

  export class Update {
    public static readonly type = `[${title}] Update`;
    constructor(public payload: Model) {}
  }

  export class PartialUpdate {
    public static readonly type = `[${title}] Partial Update`;
    constructor(public uid: string, public payload: Partial<Model>) {}
  }
}
